//@ts-nocheck
import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../stores";
import PersonalInfo from "../tutor-revamp/PersonalInfo";
import { getCountryDialCode } from "../utils/functions";
import { CardContainer } from "./shared";
import { useSaveHook } from "./utils";

const ProfileEditPage: React.FC<{
  store: IRootStore;
  saveTutorInfo: (data: any) => Promise<any>;
  isLiteTutor?: boolean;
}> = ({ store, saveTutorInfo,isLiteTutor }) => {
  const { loading, onSubmitSection } = useSaveHook(saveTutorInfo);

  async function onFormSubmit(data) {
    store.personalInfo.onFormSubmit(data);
    const { lessonType, exemptedAreas, ...rest } =
      store.locationInfo.formValues;
    const newData = {
      personalInfo: { ...store.personalInfo.formValues, ...rest },
      identity: store.identity.formValues(),
    };
    return onSubmitSection(newData);
  }

  return (
    <Box>
      <CardContainer heading="Personal Info">
        <PersonalInfo
          store={store.personalInfo}
          imageStore={store.identity}
          countries={store.locationInfo.countryOptions}
          loading={loading}
          minCode={`+${getCountryDialCode(store.locationInfo.country)}`.length}
          onSubmit={onFormSubmit}
          onImageUpload={async (image) => {
            const r = await store.identity.onUploadPhoto(image);
            const profilePhotoId = store.identity.profilePhotoId;
            return {
              profilePhotoId,
              profilePhoto: r,
            };
          }}
          isLiteTutor={isLiteTutor}
          idVerified={store.identity.isIdVerified}
        />
      </CardContainer>
    </Box>
  );
};

export default observer(ProfileEditPage);
